export enum CareProgressBadgeType {
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  SCRIPT_WRITTEN = 'Script Written',
  NO_DOCUMENT = 'No Document',
}
export enum PMMDocument {
  HISTORY = 'PMM Medication History',
  REVIEW = 'PMM Medication Review',
  DC = 'PMM Discharge Medications',
}

export enum PMMScriptWritten {
  SCRIPT_WRITTEN = 'Script written',
}

export enum PMMMedProfile {
  MED_PROFILE = 'Med. profile',
}

export type PMMNameTypes = PMMDocument | PMMScriptWritten | PMMMedProfile;
export type CareProgressRowData = {
  id: string;
  event_date: string;
  patient_id: number;
  name: PMMNameTypes;
  tenancy_id: number;
  detail: {
    status: CareProgressBadgeType;
  };
  episode_id: number;
};
